export const pipeu = (...fns: ((v: any) => any)[]): ((x: any) => any) => {
  return x => fns.reduce((v, f) => f(v), x);
};
